export const getCitiesWithMajorByPrefecture = (prefectureName, afterProcess) => {
  if (prefectureName !== '都道府県を選択') {
    $.ajax({
      url: `/api/prefecture/${prefectureName}/cities_with_major`,
      method: 'GET',
      data: 'json',
      error: () => {
        afterProcess([]) // 失敗時は空の配列に
      },
      success: (cities) => {
        afterProcess(cities)
      }
    })
  }

  afterProcess([]) // 失敗時は空の配列に
}
